export enum TradeSateEnum {
  READY,
  EXPIRED,
  RUNNING,
  SUCCESS,
  FAILED,
}
